module.exports = __webpack_public_path__ + "img/logo.415a5175.png";